export enum Chain {
  ethereum = "ethereum",
  solana = "solana",
  hyperliquid = "hyperliquid",
}

export enum Protocol {
  PROTOCOL_UNSPECIFIED = "PROTOCOL_UNSPECIFIED",
  UNISWAP_V3 = "UNISWAP_V3",
  UNISWAP_V2 = "UNISWAP_V2",
  UNISWAP_V1 = "UNISWAP_V1",
  RAYDIUM = "RAYDIUM",
  GOOSEFX_SSL = "GOOSEFX_SSL",
  METEORA = "METEORA",
  LIFINITY = "LIFINITY",
  PHOENIX = "PHOENIX",
  WHIRLPOOL = "WHIRLPOOL",
  PUMP = "PUMP",
  MOONSHOT = "MOONSHOT",
  EGG = "EGG",
  RAYDIUM_CPMM = "RAYDIUM_CPMM",
  RAYDIUM_CLMM = "RAYDIUM_CLMM",
  ORCA_WHIRLPOOL = "ORCA_WHIRLPOOL",
  METEORA_DLMM = "METEORA_DLMM",
  METEORA_DYN = "METEORA_DYN",
  SUNPUMP = "SUNPUMP",
  GRAFUN = "GRAFUN",
  PUMPSWAP = "PUMPSWAP",
  METEORA_DYN_V2 = "METEORA_DYN_V2",
  METEORA_VIRTUAL_CURVE = "METEORA_VIRTUAL_CURVE",
  METEORA_VIRTUAL_CURVE_BELIEVE = "METEORA_VIRTUAL_CURVE_BELIEVE",
  RAYDIUM_LAUNCHPAD = "RAYDIUM_LAUNCHPAD",
  RAYDIUM_LAUNCHPAD_BONK = "RAYDIUM_LAUNCHPAD_BONK",
  BOOP = "BOOP",
  METEORA_VIRTUAL_CURVE_JUPITER_STUDIO = "METEORA_VIRTUAL_CURVE_JUPITER_STUDIO",
  METEORA_VIRTUAL_CURVE_MOONSHOT = "METEORA_VIRTUAL_CURVE_MOONSHOT",
  METEORA_VIRTUAL_CURVE_BAGS = "METEORA_VIRTUAL_CURVE_BAGS",
  METEORA_VIRTUAL_CURVE_COOKING_CITY = "METEORA_VIRTUAL_CURVE_COOKING_CITY",
}

export const getProtocolName = (protocol: Protocol) => {
  switch (protocol) {
    case Protocol.UNISWAP_V3:
      return "Uniswap V3";
    case Protocol.UNISWAP_V2:
      return "Uniswap V2";
    case Protocol.UNISWAP_V1:
      return "Uniswap V1";
    case Protocol.RAYDIUM:
      return "Raydium";
    case Protocol.GOOSEFX_SSL:
      return "GooseFX SSL";
    case Protocol.METEORA:
      return "Meteora";
    case Protocol.LIFINITY:
      return "Lifinity";
    case Protocol.PHOENIX:
      return "Phoenix";
    case Protocol.WHIRLPOOL:
      return "Whirlpool";
    case Protocol.PUMP:
      return "Pump";
    case Protocol.MOONSHOT:
      return "Moonit";
    case Protocol.EGG:
      return "Egg";
    case Protocol.RAYDIUM_CPMM:
      return "Raydium CPMM";
    case Protocol.RAYDIUM_CLMM:
      return "Raydium CLMM";
    case Protocol.ORCA_WHIRLPOOL:
      return "Orca Whirlpool";
    case Protocol.METEORA_DLMM:
      return "Meteora DLMM";
    case Protocol.METEORA_DYN:
      return "Meteora DYN";
    case Protocol.SUNPUMP:
      return "Sunpump";
    case Protocol.GRAFUN:
      return "Grafun";
    case Protocol.PUMPSWAP:
      return "Pumpswap";
    case Protocol.METEORA_DYN_V2:
      return "Meteora DYN V2";
    case Protocol.METEORA_VIRTUAL_CURVE:
      return "Dynamic BC";
    case Protocol.METEORA_VIRTUAL_CURVE_BELIEVE:
      return "Believe";
    case Protocol.RAYDIUM_LAUNCHPAD:
      return "Raydium Pad";
    case Protocol.RAYDIUM_LAUNCHPAD_BONK:
      return "Bonk";
    case Protocol.BOOP:
      return "Boop";
    case Protocol.METEORA_VIRTUAL_CURVE_JUPITER_STUDIO:
      return "Jupiter Studio";
    case Protocol.METEORA_VIRTUAL_CURVE_MOONSHOT:
      return "Moonshot";
    case Protocol.METEORA_VIRTUAL_CURVE_BAGS:
      return "Bags";
    case Protocol.METEORA_VIRTUAL_CURVE_COOKING_CITY:
      return "Cooking City";
    default:
      return protocol;
  }
};

export const isTrenchProtocol = (
  protocol: Protocol | string | null | undefined,
): boolean => {
  const trenchProtocols = new Set([
    Protocol.PUMP,
    Protocol.MOONSHOT,
    Protocol.METEORA_VIRTUAL_CURVE,
    Protocol.METEORA_VIRTUAL_CURVE_BELIEVE,
    Protocol.METEORA_VIRTUAL_CURVE_JUPITER_STUDIO,
    Protocol.METEORA_VIRTUAL_CURVE_MOONSHOT,
    Protocol.METEORA_VIRTUAL_CURVE_BAGS,
    Protocol.METEORA_VIRTUAL_CURVE_COOKING_CITY,
    Protocol.RAYDIUM_LAUNCHPAD,
    Protocol.RAYDIUM_LAUNCHPAD_BONK,
    Protocol.BOOP,
  ]);
  return protocol != null && trenchProtocols.has(protocol as Protocol);
};

export const isOrderingUnsupported = (
  protocol: Protocol,
  inverted: boolean,
) => {
  return protocol === Protocol.PUMPSWAP && inverted;
};
